module.exports = __webpack_public_path__ + "static/media/roller.52ef5f53.svg";